import { NgModule } from '@angular/core';
import {NzModalModule} from 'ng-zorro-antd/modal';
import {TranslateModule} from '@ngx-translate/core';
import {SafetyMeasuresComponent} from '@shared/safety-measures/safety-measures.component';
import {NzButtonModule} from 'ng-zorro-antd/button';
import {NzTransitionPatchModule} from 'ng-zorro-antd/core/transition-patch/transition-patch.module';
import {NzWaveModule} from 'ng-zorro-antd/core/wave';

@NgModule({
  declarations: [
    SafetyMeasuresComponent
  ],
  exports: [
    SafetyMeasuresComponent
  ],
  imports: [
    NzModalModule,
    TranslateModule,
    NzWaveModule,
    NzButtonModule,
  ]
})
export class SafetyMeasuresModule { }
